export const GENERIC_ERROR = "Hmm, that didn't work. Please try again.";
export const GENERIC_ERROR_500 =
  "We've encountered a problem. Please try again. If the problem persists, please contact us.";
